var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DatePicker',{attrs:{"showValidationErrors":_vm.showValidationErrors,"required":"","inputValue":_vm.answer},on:{"onChange":_vm.handleChange}})}
var staticRenderFns = []

export { render, staticRenderFns }